<template>
  <v-layout row justify-center class="modal">
    <v-dialog max-width="600px" v-model="visibility" @input="close">
      <v-card class="gd-background">
        <v-card-title class="remove-padding">
          <v-container class="remove-padding">
            <v-layout wrap align-center>
              <div class="modal__banner" :style="background"></div>
              <div class="modal__content">
                <v-flex xs12>
                  <img src="/static/img/logo-sd-white-175-2022.png" alt="Kopi Ketjil Logo" height="72" class="left">
                </v-flex>
                <v-flex xs12 class="text-right pl-3">
                  <span class="headline text-helvetica-xxs uppercase">{{ product.name }}</span>
                </v-flex>
              </div>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 class="text-xs-center">
                      <a :href="product.qr_alternate_url" target="_blank">
                        <img width="240" :src="qrCode" :alt="`${product.name}-qr-code`" class="white radius">
                      </a>
                    </v-flex>
                    <v-flex xs12 class="text-courier-new-xxxs text-xs-center">
                      <a :href="product.shop_url" class="link" :title="product.shop_url">Want to buy? Please click here...</a>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visibility: true
    }
  },
  computed: {
    background () {
      return `background: url(${this.getPath(this.product.image_url)}) 8% center no-repeat; background-size: cover;`
    },
    qrCode () {
      return this.getPath(this.product.qr_url)
    }
  },
  methods: {
    getPath (fileName) {
      return 'https://api.kopiketjil.com' + fileName
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  border-radius: 32px;
  position: relative;
  &__banner {
    width: 100%;
    height: 200px;
    box-shadow: inset 0 150px 75px -90px rgba(0, 0, 0, 0.41) ;
  }
  &__content {
    width: 100%;
    padding: 16px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    color: white;
  }
}
.radius {
  border-radius: 8px;
  box-shadow: 0 0 24px -4px rgba(0, 0, 0, 0.12);
}
.text-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/TraceabilityModal.vue